import { preload } from '../nojq/_load.js';

// URLs for the authentication scripts
const APPLE_AUTH_URL = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
const GOOGLE_ONE_TAP_URL = 'https://accounts.google.com/gsi/client';

// Cached Promise references so that each script is loaded only once
let appleAuthPromise = null;
let googleOneTapPromise = null;

/**
 * Loads the Apple Sign-In JavaScript SDK exactly once.
 * Subsequent calls return the same resolved Promise.
 *
 * @returns {Promise<void>}
 */
export function loadAppleAuth() {
    if (!appleAuthPromise) {
        appleAuthPromise = preload({
            files: [APPLE_AUTH_URL],
            type: 'js',
        });
    }
    return appleAuthPromise;
}

/**
 * Loads the Google One-Tap Sign-In JavaScript SDK exactly once.
 * Subsequent calls return the same resolved Promise.
 *
 * @returns {Promise<void>}
 */
export function loadGoogleOneTapSignin() {
    if (!googleOneTapPromise) {
        googleOneTapPromise = preload({
            files: [GOOGLE_ONE_TAP_URL],
            type: 'js',
        });
    }
    return googleOneTapPromise;
}
